(function ($, Drupal, once) {
  Drupal.behaviors.halifax_alert_banner = {
    attach: function (context) {
      once(
        'halifax_alert_banner',
        'button.hfx-alert-banner__toggle',
        context
      ).forEach((element) => {
        const alertBannerButton = $(element);
        if (alertBannerButton.length) {
          const newsReleaseAlertBanner = document.getElementById(
            'HfxNewsReleaseAlertBanner'
          );
          // Change the aria label based on the state of the alert banner for screen reader accessibility:
          newsReleaseAlertBanner.addEventListener(
            'hidden.bs.collapse',
            function toggleOpen() {
              alertBannerButton.attr('aria-labelledby', 'toggle-label-open');
            }
          );
          newsReleaseAlertBanner.addEventListener(
            'shown.bs.collapse',
            function toggleClosed() {
              alertBannerButton.attr('aria-labelledby', 'toggle-label-close');
            }
          );
        }
      });
    },
  };
})(jQuery, Drupal, once);
